import { EventType } from "src/app/core/models/EventType";

export interface CustomerStory {
    webp_photo_url?: string;
    photo_url: string;
    description: string;
    action_url?: string;
    logo_url: string;
    dark_logo_url: string;
    customer_name: string;
    customer_role: string;
    types: EventType[];
}

export const CustomerStories : CustomerStory[] = [
    {
        "customer_name": "Solène Sénéclauze",
        "customer_role": $localize`Chargée de production sur le festival Aluna`,
        "description": $localize`Qoezion facilite également la gestion durant l’événement avec une visibilité rapide des équipes.`,
        "photo_url": "assets/stories/aluna/solene-seneclauze.jpg",
        "logo_url": "assets/stories/aluna/logo-aluna-dark.svg",
        "dark_logo_url":"assets/stories/aluna/logo-aluna.svg",
        "types": [EventType.CULTURE]
    },
    {
        "customer_name": "Adrien Balduzzi",
        "customer_role": $localize`Représentant de la Fédération Française Handisport`,
        "description": $localize`Si nous avons décidé d’utiliser Qoezion c’est aussi de par son ergonomie et sa facilité d’utilisation, c’est assez ludique.`,
        "photo_url": "assets/stories/ffh/adrien-balduzzi.jpg",
        "logo_url": "assets/stories/ffh/logo-handisport.svg",
        "dark_logo_url":"assets/stories/ffh/logo-handisport-white.svg",
        "types": [EventType.SPORT, EventType.MULTI]
    },
    {
        "customer_name": "Christophe Gay",
        "customer_role": $localize`Responsable des bénévoles de la Volvic Volcanic eXperience`,
        "description": $localize`Avec la messagerie intégrée du logiciel Qoezion nous pouvons envoyer des messages plus simplement et rapidement.`,
        "photo_url": "assets/stories/vvx/christophe-gay.jpg",
        "logo_url": "assets/stories/vvx/logo-vvx.png",
        "dark_logo_url":"assets/stories/vvx/logo-vvx-white.png",
        "types": [EventType.SPORT]
    },
    {
        "customer_name": "Nadège Sionnet",
        "customer_role": $localize`Chef de projet chez International Aids Society`,
        "description": $localize`L'outil permet une réelle économie de temps, d’énergie et de ressources, à court comme à long terme.`,
        "photo_url": "assets/stories/ias/nadege-sionnet.jpg",
        "logo_url": "assets/stories/ias/logo-ias.png",
        "dark_logo_url":"assets/stories/ias/logo-ias.png",
        "types": []
    },
    {
        "customer_name": "Manon Tanguy",
        "customer_role": $localize`Assistante Événements et Partenariats à la Fédération Française de Canoë-Kayak`,
        "description": $localize`Cet outil simplifie nos méthodes de travail et facilite le recrutement des bénévoles sur nos manifestations. Qoezion nous permet également de centraliser l’ensemble des informations.`,
        "photo_url": "assets/stories/ffck/manon-tanguy.jpg",
        "logo_url": "assets/stories/ffck/logo-ffck.svg",
        "dark_logo_url":"assets/stories/ffck/logo-ffck-white.svg",
        "types": [EventType.SPORT, EventType.MULTI]
    },
    {
        "customer_name": "Laurence Rey",
        "customer_role": $localize`Animatrice réseau des bénévoles, le Grand Bornand`,
        "description": $localize`Nous utilisons Qoezion depuis 2019. Les fonctionnalités déployées et les améliorations continues sont top. Et une mention spéciale pour le support qui est très réactif !`,
        "photo_url": "assets/stories/grand-bornand/laurence-rey.jpg",
        "logo_url": "assets/stories/grand-bornand/logo-grand-bornand.svg",
        "dark_logo_url":"assets/stories/grand-bornand/logo-grand-bornand-white.svg",
        "types": [EventType.SPORT, EventType.MULTI]
    }
]
